import { useState, useEffect } from "react";
import {
  getCrmAktiviteler, addCrmAktivite, toggleCrmAktiviteTamamla, deleteCrmAktivite,
  getCrmFirmalar, getCrmKisiler, getCrmFirsatlar, getCrmPlasiyerler,
} from "../services/api";

const TIPLER = ["Arama", "Toplanti", "Email", "Not", "Gorev"];
const TIP_IKON = { Arama: "📞", Toplanti: "🤝", Email: "✉️", Not: "📝", Gorev: "✅" };

const today = new Date().toISOString().slice(0, 10);
const EMPTY_FORM = { firma_id: "", kisi_id: "", firsat_id: "", tip: "Not", baslik: "", aciklama: "", tarih: today, sorumlu_kullanici: "" };

const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
const th   = { padding: "10px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "var(--text-muted)", borderBottom: "1px solid var(--border-hairline)", textTransform: "uppercase", letterSpacing: ".05em" };
const td   = { padding: "11px 14px", fontSize: 13, color: "var(--text-primary)", borderBottom: "1px solid var(--border-hairline)" };
const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

export default function CrmAktiviteler() {
  const [aktiviteler, setAktiviteler] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [kisiler, setKisiler] = useState([]);
  const [firsatlar, setFirsatlar] = useState([]);
  const [plasiyerler, setPlasiyerler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [sadeceAcik, setSadeceAcik] = useState(false);

  useEffect(() => {
    getCrmFirmalar().then((r) => setFirmalar(r.data)).catch(() => {});
    getCrmFirsatlar().then((r) => setFirsatlar(r.data)).catch(() => {});
    getCrmPlasiyerler().then((r) => setPlasiyerler(r.data)).catch(() => {});
    load();
  }, []);

  useEffect(() => { load(); }, [sadeceAcik]);

  useEffect(() => {
    if (!form.firma_id) { setKisiler([]); return; }
    getCrmKisiler({ firma_id: form.firma_id }).then((r) => setKisiler(r.data)).catch(() => {});
  }, [form.firma_id]);

  async function load() {
    setLoading(true);
    try {
      setAktiviteler((await getCrmAktiviteler(sadeceAcik ? { tamamlandi: false } : {})).data);
    } catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await addCrmAktivite({
        ...form,
        firma_id: form.firma_id || null,
        kisi_id: form.kisi_id ? Number(form.kisi_id) : null,
        firsat_id: form.firsat_id ? Number(form.firsat_id) : null,
      });
      flash("Aktivite eklendi");
      setForm({ ...EMPTY_FORM, tarih: today });
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata", "error");
    }
  }

  async function handleToggle(id) {
    try {
      await toggleCrmAktiviteTamamla(id);
      load();
    } catch { flash("Guncellenemedi", "error"); }
  }

  async function handleDelete(id, baslik) {
    if (!window.confirm(`"${baslik}" silinsin mi?`)) return;
    try {
      await deleteCrmAktivite(id);
      flash("Silindi");
      load();
    } catch { flash("Silinemedi", "error"); }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 16 }}>Yeni Aktivite Ekle</div>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TIP</div>
              <select style={inp} value={form.tip} onChange={(e) => setForm({ ...form, tip: e.target.value })}>
                {TIPLER.map((t) => <option key={t} value={t}>{TIP_IKON[t]} {t}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>BASLIK</div>
              <input style={inp} value={form.baslik} required
                onChange={(e) => setForm({ ...form, baslik: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TARIH</div>
              <input style={inp} type="date" value={form.tarih}
                onChange={(e) => setForm({ ...form, tarih: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>FIRMA</div>
              <select style={inp} value={form.firma_id}
                onChange={(e) => setForm({ ...form, firma_id: e.target.value, kisi_id: "" })}>
                <option value="">Yok</option>
                {firmalar.map((f) => <option key={f.CARI_KOD} value={f.CARI_KOD}>{f.Unvan}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>KISI</div>
              <select style={inp} value={form.kisi_id} onChange={(e) => setForm({ ...form, kisi_id: e.target.value })}>
                <option value="">Yok</option>
                {kisiler.map((k) => <option key={k.ID} value={k.ID}>{k.AdSoyad}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>FIRSAT</div>
              <select style={inp} value={form.firsat_id} onChange={(e) => setForm({ ...form, firsat_id: e.target.value })}>
                <option value="">Yok</option>
                {firsatlar.map((f) => <option key={f.ID} value={f.ID}>{f.Baslik}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>SORUMLU</div>
              <select style={inp} value={form.sorumlu_kullanici}
                onChange={(e) => setForm({ ...form, sorumlu_kullanici: e.target.value })}>
                <option value="">Secilmedi</option>
                {plasiyerler.map((p) => <option key={p.PLASIYER_KODU} value={p.Ad}>{p.Ad}</option>)}
              </select>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>ACIKLAMA</div>
              <input style={inp} value={form.aciklama}
                onChange={(e) => setForm({ ...form, aciklama: e.target.value })} />
            </div>
          </div>
          <button type="submit" style={btn("var(--accent)", "#fff")}>Aktivite Ekle</button>
        </form>
      </div>

      <div style={{ ...card, display: "flex", gap: 10, alignItems: "center" }}>
        <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, color: "var(--text-secondary)", cursor: "pointer" }}>
          <input type="checkbox" checked={sadeceAcik} onChange={(e) => setSadeceAcik(e.target.checked)} />
          Sadece tamamlanmamislari goster
        </label>
      </div>

      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "var(--bg-sidebar)" }}>
              {["Tip", "Baslik", "Tarih", "Firma", "Kisi", "Firsat", "Durum", ""].map((h) => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Yukleniyor...</td></tr>}
            {!loading && aktiviteler.length === 0 && <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Henuz aktivite eklenmemis.</td></tr>}
            {aktiviteler.map((a) => (
              <tr key={a.ID}
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-card-alt)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                <td style={td}>{TIP_IKON[a.Tip]} {a.Tip}</td>
                <td style={{ ...td, fontWeight: 600 }}>{a.Baslik}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{String(a.Tarih).slice(0, 10)}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{a.FirmaUnvani || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{a.KisiAdi || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{a.FirsatBasligi || "-"}</td>
                <td style={td}>
                  <span style={{
                    padding: "3px 9px", borderRadius: 99, fontSize: 11, fontWeight: 600,
                    background: a.TamamlandiMi ? "#0d3b2e" : "#2d1b00",
                    color: a.TamamlandiMi ? "#34d399" : "#fb923c",
                  }}>
                    {a.TamamlandiMi ? "Tamamlandi" : "Bekliyor"}
                  </span>
                </td>
                <td style={{ ...td, display: "flex", gap: 6 }}>
                  <button onClick={() => handleToggle(a.ID)}
                    style={{ background: "var(--accent-bg)", color: "var(--accent-text)", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                    {a.TamamlandiMi ? "Geri Al" : "Tamamla"}
                  </button>
                  <button onClick={() => handleDelete(a.ID, a.Baslik)}
                    style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                    Sil
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
